import request from '@/utils/request'

/**
 * App 内 Contact us 留言：落库，manage 定时任务发邮件到 support@
 * @param {{subject: string, content: string, page?: string}} data
 */
export function submit(data) {
  return request({
    url: '/app-message/submit',
    method: 'post',
    // 请求拦截器默认会把 data 用 qs 序列化成 x-www-form-urlencoded，
    // 后端是 @RequestBody（JSON），必须显式声明 json
    type: 'json',
    data
  })
}
